import { Box } from '@chakra-ui/react'
import {
  ContentNotFound,
  DiscoverSsm,
  Hero,
  Layout,
  Sections,
  StickyHeader,
  SsmInstagram,
} from '@common'
import { ISSRPageData } from '@interfaces'
import { PageService } from '@services'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const VisitScreen = ({ pageData, global: { navigation } }: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  if (pageData.error) {
    return (
      <Layout
        title={t('common:ssmPageTitle')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    )
  }

  return (
    <Layout
      title={pageData.data.pageTitle}
      navigation={navigation}
      path={asPath}
    >
      <Hero
        subTitle={pageData.data.hero.subTitle}
        title={pageData.data.hero.title}
        description={pageData.data.hero.description}
        bgImageUrl={pageData.data.hero.bgImageUrl}
        bgImageUrlMobile={pageData.data.hero.bgImageUrlMobile }
      />
      {pageData.data.stickyNavItems &&
        pageData.data.stickyNavItems.length > 0 && (
          <Box as="main">
            <StickyHeader navs={pageData.data.stickyNavItems} />
            <Sections sections={pageData.data.sections} withDivider={true} />
          </Box>
        )}
      {pageData.data?.exploreSSM.length > 0 && (
        <DiscoverSsm
          subTitle={t('common:discoverSsm.title1')}
          title={t('common:discoverSsm.title2')}
          description={t('common:discoverSsm.description')}
          sliderCollection={pageData.data?.exploreSSM}
        />
      )}
      {pageData.data?.instagramMedia && (
        <SsmInstagram media={pageData.data?.instagramMedia} />
      )}
    </Layout>
  )
}

export default VisitScreen

export async function getStaticProps({ locale }) {
  const pageData = await PageService.getDefaultLayoutPageData(locale, 'visit')

  return {
    props: { pageData },
  }
}
